import cx from 'classnames'
import { Row, Col } from 'antd'
import styles from './index.css'
import { ERROR, INFO } from '../../../../constants/globalTypes'

const PrefixBlock = props => {
  const {
    type,
    className,
    children
  } = props
  return (
    <Row
      type='flex'
      align='middle'
      justify='space-between'
      className={cx(
        styles.prefixBlock,
        { [styles.info]: type === INFO },
        { [styles.error]: type === ERROR },
        { [className]: className }
      )}
    >
      <Col>
        {children}
      </Col>
    </Row>
  )
}

export default PrefixBlock
